import React from "react";
import { useNavigate } from "react-router-dom";
import { reactIcons } from "../../utils/icons";

const BackButton = ({ text = "", onClick, className = "" }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`flex items-center gap-2 p-1 border border-gray-300 rounded-full  bg-primary-100 text-lg  transition ${className}`}
    >
      <span className="text-white text-28">{reactIcons.arrowleft}</span>
      {text}
    </button>
  );
};

export default BackButton;
